<app-filter-header title="Filtrar temporades" i18n-title (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row col">
    <app-form-text-edit class="col-sm-3" i18n-label label="Codi" [(value)]="this.filter.id" number></app-form-text-edit>
    <app-filter-text-edit class="col-sm-9" i18n-label label="Descripció" [(value)]="this.filter.descripcion" contains></app-filter-text-edit>
    <app-form-tri-state label="Activa" i18n-label  i18n-labelSi labelSi="Si" i18n-labelNo labelNo = "No" i18n-labelTodos labelTodos="Tots" [(value)]="this.filter.activa"></app-form-tri-state>
  </div>
</div>
